import { mapGetters } from 'vuex'

export const rulesMixin = {
    computed: {
        ...mapGetters([
            'getRules',
            'getRulesGroups'
        ])
    },
    methods: {
        nextValidId: function (type) {
            const rules = type === 'rules' ? this.getRules : this.getRulesGroups;
            const idsExistente = new Set(rules.map(rule => rule.id)); // Initialises a set with all existing ids
            let netxId = 1;

            // As long as the next id is in the set of existing ids, increment
            while (idsExistente.has(netxId)) {
                netxId++;
            }

            return netxId;
        },
    },
}


// WEBPACK FOOTER //
// ./src/mixins/rules.js